<template>
  <edit-form
    ref="form"
    :data="data"
    :dataID="data.id"
    :model="formModel"
    @updateModelItem="onUpdateModelItem"
  ></edit-form>
</template>
<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
export default {
  name: 'SectionRFQ',
  mixins: [FormWrapperAutoSave],
  components: {
    'edit-form': () => import(/* webpackChunkName: 'RFQPurchase' */ './FormRFQ.vue')
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    isAvailableToSave () {
      return true
    }
  },
  methods: {
    formModel () {
      return {
        id: null,
        rfqid: '',
        customerCompanyID: null,
        customerCompanyDetailID: null,
        customerContactID: null,
        requestedDate: null,
        rfqTypeID: null,
        baxEmployeeID: this.$store.getters.get('currentUser').employeeID,
        po: '',
        poDate: null,
        pOisOpen: true,

        shipToCompanyID: null,
        shipToContactID: null,
        shipToCompanyDetailID: null,
        customerForwarderID: null,
        priorityID: null,
        orderRatingScoreID: null,
        paymentTermID: null,
        observation: ''
      }
    },
    onUpdateModelItem () {
      this.handlerUpdateModelItem(...arguments)
      const dataRFQ = this.$refs.form.getData()
      this.$emit('updateModelItem', dataRFQ)
    }
  }
}
</script>
